import { object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

export const SLUG_REGEX = /^[a-z0-9_-]+$/

// Mirrors EventType::RESERVED_SLUGS in the calendly monolith. These words conflict
// with internal booking-page routes (/{user}/payments, /{user}/packages, etc.) and
// must stay in sync with the backend validation.
export const RESERVED_SLUGS = ['payments', 'packages', 'invoices']

export const getValidationSchema = () => object({
  slug: string()
    .required(I18n.t('activerecord.errors.models.event_type_base.attributes.slug.blank'))
    .matches(SLUG_REGEX, {
      message: I18n.t('activerecord.errors.models.event_type_base.attributes.slug.invalid'),
      excludeEmptyString: true
    })
    .notOneOf(
      RESERVED_SLUGS,
      I18n.t('activerecord.errors.models.event_type_base.attributes.slug.exclusion')
    )
})
